(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "67ee5036a7b175710c0cce94";
              window.beaePageSetting.pageTitle = "oumurs-footer"; 
              window.beaePageSetting.pageType = "footer";

          let js_5PNO2FPD = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-rluo4pslsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-rluo4psl',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-rluo4psl');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}}else if(n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-rluo4psl: ', ex)
      };
    

      try {
        let argid = 'beae-lgghc5cglinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lgghc5cg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lgghc5cg');
        args.el = args.els[0];
        ((v) => { const g=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");g===null||w===null||g.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lgghc5cg: ', ex)
      };
    

      try {
        let argid = 'beae-86dyzjc6linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-86dyzjc6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-86dyzjc6');
        args.el = args.els[0];
        ((v) => { const g=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");g===null||w===null||g.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-86dyzjc6: ', ex)
      };
    

      try {
        let argid = 'beae-ki6iodpglinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-ki6iodpg',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-ki6iodpg');
        args.el = args.els[0];
        ((v) => { const g=v.el.querySelector(".beae-linkslist-title"),w=v.el.querySelector(".beae-linkslist");g===null||w===null||g.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&w.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-ki6iodpg: ', ex)
      };
    

      try {
        let argid = 'beae-nebkri9vsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nebkri9v',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nebkri9v');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nebkri9v: ', ex)
      };
    

      try {
        let argid = 'beae-cef94j1jblock-imageloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cef94j1j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cef94j1j');
        args.el = args.els[0];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var E=H.querySelector(".beae-img-ratio-control"),N=H.querySelector(".beae-img-comp-container"),O=H.querySelector(".beae-img-comp-container--second");if(E&&O){let P=function(A){let D=0,q,R;j(),I?H.onmouseover=function(X){Z(X)}:A.onmousedown=function(X){Z(X)},H.onmouseup=function(){F()},A.ontouchstart=function(X){Z(X)},H.ontouchend=function(){F()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),A.style.left&&(q=parseInt(A.style.left))}function Z(X){check=!1,X.preventDefault(),X.clientX?X.clientX:X.touches[0].clientX,q=parseInt(A.style.left),D=1,H.onmousemove=function(oe){G(oe)},H.ontouchmove=function(oe){G(oe)}}function F(){D=0,isNaN(R)||(q=R),check=!0}function G(X){if(D==0)return!1;R=W(X),R<0&&(R=0),R>100&&(R=100),J(R)}function W(X){const oe=H.getBoundingClientRect(),se=X.changedTouches?X.changedTouches[0].clientX:X.clientX,ae=se-oe.left;let le;return I?le=Math.round(ae*100/z):le=Math.round(q-(se-X.pageX)*100/z),le}function J(X){A.style.left=X+"%",O.style.clipPath=`polygon(${X}% 0%, ${X}% 100%, 100% 100%, 100% 0)`,N.style.clipPath=`polygon(0% 100%, 0% 0%, ${X}% 0%, ${X}% 100%)`}};E&&O&&P(E),window.addEventListener("resize",function(){E&&O&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),P(E))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cef94j1j: ', ex)
      };
    

      try {
        let argid = 'beae-cef94j1jblock-imageloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cef94j1j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cef94j1j');
        args.el = args.els[1];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var E=H.querySelector(".beae-img-ratio-control"),N=H.querySelector(".beae-img-comp-container"),O=H.querySelector(".beae-img-comp-container--second");if(E&&O){let P=function(A){let D=0,q,R;j(),I?H.onmouseover=function(X){Z(X)}:A.onmousedown=function(X){Z(X)},H.onmouseup=function(){F()},A.ontouchstart=function(X){Z(X)},H.ontouchend=function(){F()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),A.style.left&&(q=parseInt(A.style.left))}function Z(X){check=!1,X.preventDefault(),X.clientX?X.clientX:X.touches[0].clientX,q=parseInt(A.style.left),D=1,H.onmousemove=function(oe){G(oe)},H.ontouchmove=function(oe){G(oe)}}function F(){D=0,isNaN(R)||(q=R),check=!0}function G(X){if(D==0)return!1;R=W(X),R<0&&(R=0),R>100&&(R=100),J(R)}function W(X){const oe=H.getBoundingClientRect(),se=X.changedTouches?X.changedTouches[0].clientX:X.clientX,ae=se-oe.left;let le;return I?le=Math.round(ae*100/z):le=Math.round(q-(se-X.pageX)*100/z),le}function J(X){A.style.left=X+"%",O.style.clipPath=`polygon(${X}% 0%, ${X}% 100%, 100% 100%, 100% 0)`,N.style.clipPath=`polygon(0% 100%, 0% 0%, ${X}% 0%, ${X}% 100%)`}};E&&O&&P(E),window.addEventListener("resize",function(){E&&O&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),P(E))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cef94j1j: ', ex)
      };
    

      try {
        let argid = 'beae-cef94j1jblock-imageloop-2',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cef94j1j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cef94j1j');
        args.el = args.els[2];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var E=H.querySelector(".beae-img-ratio-control"),N=H.querySelector(".beae-img-comp-container"),O=H.querySelector(".beae-img-comp-container--second");if(E&&O){let P=function(A){let D=0,q,R;j(),I?H.onmouseover=function(X){Z(X)}:A.onmousedown=function(X){Z(X)},H.onmouseup=function(){F()},A.ontouchstart=function(X){Z(X)},H.ontouchend=function(){F()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),A.style.left&&(q=parseInt(A.style.left))}function Z(X){check=!1,X.preventDefault(),X.clientX?X.clientX:X.touches[0].clientX,q=parseInt(A.style.left),D=1,H.onmousemove=function(oe){G(oe)},H.ontouchmove=function(oe){G(oe)}}function F(){D=0,isNaN(R)||(q=R),check=!0}function G(X){if(D==0)return!1;R=W(X),R<0&&(R=0),R>100&&(R=100),J(R)}function W(X){const oe=H.getBoundingClientRect(),se=X.changedTouches?X.changedTouches[0].clientX:X.clientX,ae=se-oe.left;let le;return I?le=Math.round(ae*100/z):le=Math.round(q-(se-X.pageX)*100/z),le}function J(X){A.style.left=X+"%",O.style.clipPath=`polygon(${X}% 0%, ${X}% 100%, 100% 100%, 100% 0)`,N.style.clipPath=`polygon(0% 100%, 0% 0%, ${X}% 0%, ${X}% 100%)`}};E&&O&&P(E),window.addEventListener("resize",function(){E&&O&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),P(E))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cef94j1j: ', ex)
      };
    

      try {
        let argid = 'beae-cef94j1jblock-imageloop-3',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cef94j1j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cef94j1j');
        args.el = args.els[3];
        ((T) => { if(T.el){let H=T.el.querySelector(".beae-image-content-position"),z,I=T.autoHover;var E=H.querySelector(".beae-img-ratio-control"),N=H.querySelector(".beae-img-comp-container"),O=H.querySelector(".beae-img-comp-container--second");if(E&&O){let P=function(A){let D=0,q,R;j(),I?H.onmouseover=function(X){Z(X)}:A.onmousedown=function(X){Z(X)},H.onmouseup=function(){F()},A.ontouchstart=function(X){Z(X)},H.ontouchend=function(){F()};function j(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),A.style.left&&(q=parseInt(A.style.left))}function Z(X){check=!1,X.preventDefault(),X.clientX?X.clientX:X.touches[0].clientX,q=parseInt(A.style.left),D=1,H.onmousemove=function(oe){G(oe)},H.ontouchmove=function(oe){G(oe)}}function F(){D=0,isNaN(R)||(q=R),check=!0}function G(X){if(D==0)return!1;R=W(X),R<0&&(R=0),R>100&&(R=100),J(R)}function W(X){const oe=H.getBoundingClientRect(),se=X.changedTouches?X.changedTouches[0].clientX:X.clientX,ae=se-oe.left;let le;return I?le=Math.round(ae*100/z):le=Math.round(q-(se-X.pageX)*100/z),le}function J(X){A.style.left=X+"%",O.style.clipPath=`polygon(${X}% 0%, ${X}% 100%, 100% 100%, 100% 0)`,N.style.clipPath=`polygon(0% 100%, 0% 0%, ${X}% 0%, ${X}% 100%)`}};E&&O&&P(E),window.addEventListener("resize",function(){E&&O&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{z=O.offsetWidth})}).observe(O),P(E))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cef94j1j: ', ex)
      };
    }; if (window.BEAEBASE) {js_5PNO2FPD()} else {window.BEAEPAGEJS.push(js_5PNO2FPD)} })(); 